import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import {PageSize} from "./arts";
import ArtsDataService from "./arts.data.service";
import GalleryView from "./gallery-grid.view";
import { IApplicationState, IGalleryItem, IHttpCollectionResult } from "../../typings";

export interface GalleryGridProps extends RouteComponentProps<any> {
  request?: (pageSize: number, pageIndex: number, rarity?: number, textFilter?: string) => Promise<IHttpCollectionResult<IGalleryItem>>;
  header?: any;
  colNumber?: number;
  pageSize?: number;
  rarityFilter?: number;
  dataService?: ArtsDataService;
  pageNumber?: number;
  noChangeLocation?: boolean;
  showWarning?: boolean;
  textFilter?: string;
  urlPreffix: string;
  showTemplate?: boolean;
}

export interface GalleryGridState {
    data: IGalleryItem[];
    total: number;
    currentPage: number;
}

export class GalleryGrid extends React.Component<GalleryGridProps, GalleryGridState> {
  constructor(props: GalleryGridProps) {
    super(props);
    this.state = {
        data: [],
        total: 0,
        currentPage: 1,
    };
  }

  public componentDidMount() {
      this.load(this.props.pageSize || PageSize, this.props.pageNumber || 1);
  }

  public componentWillReceiveProps(nextProps: GalleryGridProps) {
    if (nextProps.rarityFilter !== this.props.rarityFilter || nextProps.textFilter !== this.props.textFilter) {
      this.load(nextProps.pageSize || 10, nextProps.pageNumber || 1, nextProps.rarityFilter, nextProps.textFilter);
    }
  }

  public load = (pageSize: number, pageNumber: number, rarityFilter?: number, textFilter?: string) => {
    if (this.props.dataService) {
      this.props.dataService.getGalleryItems(pageSize, pageNumber, rarityFilter, textFilter).then((result) => {
        if (result.count > 0) {
          this.setState({data: result.results, total: result.results[0].pages, currentPage: pageNumber});
        } else {
          this.setState({ data: [], total: 0, currentPage: 1 });
        }
      });
    } else if (this.props.request) {
      this.props.request(pageSize, pageNumber, rarityFilter, textFilter).then((result) => {
        if (result.count > 0) {
          this.setState({data: result.results, total: result.results[0].pages, currentPage: pageNumber});
        } else {
          this.setState({ data: [], total: 0, currentPage: 1 });
        }
      });
    }
  }

  public changeLocationAndPage = (pageSize, pageNumber) => {
    if (!this.props.noChangeLocation) {
      this.props.history.push(`/arts?pageSize=${pageSize}&pageNumber=${pageNumber}&rarity=${this.props.rarityFilter}&search=${this.props.textFilter}`);
    }
    this.load(pageSize, pageNumber, this.props.rarityFilter, this.props.textFilter);
  }

  public render() {
    return (
      <GalleryView
        colNumber={this.props.colNumber}
        header={this.props.header}
        currentPage={this.state.currentPage}
        load={this.changeLocationAndPage}
        data={this.state.data}
        showWarning={true}
        showTemplate={this.props.showTemplate}
        urlPreffix={this.props.urlPreffix}
        total={this.state.total}
      />
    );
  }
}

function mapStateToProps(state: IApplicationState, ownProps) {

  return {
    ...ownProps,
  };
}

export default connect(mapStateToProps)(GalleryGrid);



// WEBPACK FOOTER //
// ./src/components/arts/gallery-grid.tsx